import Marquee from "react-fast-marquee";
import { Hexagon } from "lucide-react";

const words = [
  "ApiaryKeeper",
  "Ask a Bee™",
  "AI-Powered Insights",
  "BeeCredits™",
  "Hive Tracking",
  "Inspection Logs",
];

export default function EditorialMarquee() {
  return (
    <div className="bg-honey/15 border-y border-forest/10 py-5 overflow-hidden" data-testid="editorial-marquee">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {words.map((w) => (
          <span key={w} className="flex items-center">
            <span className="font-display italic text-xl md:text-2xl text-forest/80 px-6">{w}</span>
            <Hexagon className="w-3 h-3 text-honey-dark" strokeWidth={2} />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
